/* import __COLOCATED_TEMPLATE__ from './radio-group.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();